import React from 'react';

import { SelectionState } from '~support-at-home/lib/contributionSelection';

import { TooltipPortal } from '~components';
import ContributionSelectCheckbox, {
  SelectSlotPlaceholder,
} from '~support-at-home/components/config/contributions/ContributionSelectCheckbox';

interface ComponentProps {
  selection?: { state: SelectionState; disabled: boolean; onToggle: () => void };
}

const LABEL_ID = 'sah-client-contributions-header-client-category';

const CAPTION =
  'Each client with how many contributions they have (use + to add another), then the category of each contribution. Tick to select current and future contributions for a bulk update';

// The first column's header: the select-all checkbox in the same left-hand column as the row
// checkboxes, then the label, which alone carries the caption tooltip. The column is not sortable, so
// a click on the checkbox cannot sort it. Called as a plain function
// from list.ts.
const ContributionClientCategoryHeader = ({ selection }: ComponentProps) => (
  <span className="contribution-header-cell d-flex align-items-center gap-2">
    {selection ? (
      <ContributionSelectCheckbox
        id="sah-client-contributions-select-all"
        label="Select all current and future contributions on this page"
        checked={selection.state === 'all'}
        indeterminate={selection.state === 'some'}
        // The page-level control is always drawn.
        anySelected
        disabled={selection.disabled}
        onChange={selection.onToggle}
      />
    ) : (
      <SelectSlotPlaceholder />
    )}
    <span id={LABEL_ID} className="has-caption">
      Client / Category
    </span>
    <TooltipPortal targetId={LABEL_ID} placement="top" showDelay={100} content={CAPTION} />
  </span>
);

export default ContributionClientCategoryHeader;
